module.exports = __webpack_public_path__ + "img/bory2_small.d34d159e.png";